import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\PasskeyAuthenticationController::authenticationOptions
* @see Http/Controllers/Auth/PasskeyAuthenticationController.php:22
* @route '/passkeys/authentication-options'
*/
export const authenticationOptions = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: authenticationOptions.url(options),
    method: 'get',
})

authenticationOptions.definition = {
    methods: ["get","head"],
    url: '/passkeys/authentication-options',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\PasskeyAuthenticationController::authenticationOptions
* @see Http/Controllers/Auth/PasskeyAuthenticationController.php:22
* @route '/passkeys/authentication-options'
*/
authenticationOptions.url = (options?: RouteQueryOptions) => {
    return authenticationOptions.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PasskeyAuthenticationController::authenticationOptions
* @see Http/Controllers/Auth/PasskeyAuthenticationController.php:22
* @route '/passkeys/authentication-options'
*/
authenticationOptions.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: authenticationOptions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\PasskeyAuthenticationController::authenticationOptions
* @see Http/Controllers/Auth/PasskeyAuthenticationController.php:22
* @route '/passkeys/authentication-options'
*/
authenticationOptions.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: authenticationOptions.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\PasskeyAuthenticationController::login
* @see Http/Controllers/Auth/PasskeyAuthenticationController.php:27
* @route '/passkeys/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: login.url(options),
    method: 'post',
})

login.definition = {
    methods: ["post"],
    url: '/passkeys/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\PasskeyAuthenticationController::login
* @see Http/Controllers/Auth/PasskeyAuthenticationController.php:27
* @route '/passkeys/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PasskeyAuthenticationController::login
* @see Http/Controllers/Auth/PasskeyAuthenticationController.php:27
* @route '/passkeys/login'
*/
login.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: login.url(options),
    method: 'post',
})

const passkeys = {
    authenticationOptions: Object.assign(authenticationOptions, authenticationOptions),
    login: Object.assign(login, login),
}

export default passkeys